import React from 'react';
import { OnboardingModal } from '@/components/onboarding/OnboardingModal';
import { useUser } from '@/lib/contexts/UserContext';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export function OnboardingPage() {
  const { user, needsOnboarding } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    // If user is not authenticated, redirect to login
    if (!user) {
      navigate('/auth');
      return;
    }

    // If onboarding is not needed, redirect to home
    if (!needsOnboarding) {
      navigate('/');
    }
  }, [user, needsOnboarding, navigate]);

  return (
    <div className="min-h-screen bg-background">
      <OnboardingModal />
    </div>
  );
} 